/* eslint-disable react/no-children-prop */
import { memo } from "react";
import PropTypes from "prop-types";
import PassengersCounterDisplay from "app/pages/.shared/PassengersCounterDisplay";
import { FormattedMessage, FormattedPlural } from "react-intl";
import "./OccupanciesDisplayLabel.scss";
import { mapOccupanciesToAdultsAndChildrenCount } from "app/utils/utils";

const OccupanciesDisplayLabel = ({ occupancies = [], showPrefix = true }) => {
	const roomTotal = occupancies.length;

	const { adults, children } = mapOccupanciesToAdultsAndChildrenCount(occupancies);

	const prefix = (
		<FormattedPlural
			value={roomTotal}
			one={
				<FormattedMessage
					values={{
						count: roomTotal,
					}}
					id="general.room.count.label.singular"
				/>
			}
			other={
				<FormattedMessage
					values={{
						count: roomTotal,
					}}
					id="general.room.count.label.plural"
				/>
			}
		/>
	);

	return (
		<PassengersCounterDisplay
			adults={adults}
			children={children}
			{...(showPrefix && { prefix })}
		/>
	);
};

OccupanciesDisplayLabel.propTypes = {
	occupancies: PropTypes.array,
	showPrefix: PropTypes.bool,
};

export default memo(OccupanciesDisplayLabel);
